import user from "../../../../assets/images/video-card.png";
import styles from "./style.module.scss";
import { useParams } from "react-router-dom";
import { database } from '../../../../firebase'
import { useEffect, useState } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import Select from "react-select";
import { Router, Route, Link,Redirect } from 'react-router-dom';
import { withRouter } from "react-router-dom";

import './index.css'
import Loader from "../../../../components/Loader";
const SenderInfo = ({history}) => {
const [loading,setLoading]=useState(false)


  let { id } = useParams();

  const [user, setuser] = useState([])
  const [allusers, setAll] = useState([{ label: "", key: "" }])
  function getUserData() {
    return database.ref("users/" + id).once("value", (snap) => {
      setuser(snap.val())

    });
  }

  useEffect(() => {
    getUserData();
  }, [id])
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.infos}>


          {id === 'new' ? 
           <h5>Select a Contact to Chat</h5>
            :

            <div className={styles.name}>
            <img src={user ? user?.profileImageUrl : null} alt="avatar" />
             
            
             { user ?  " "+"  " + user.fullName : ""} </div>

          /* <div className={styles.status}>
          { <div className={styles.indicator} />
          <div>Active</div>
        </div> */}
        </div>
        
      </div>
      <hr className={styles.hr} />
    </div>
  )
}

export default withRouter(SenderInfo);
